import { TableCell, TableHeading, TableRow, Table, SupportLayout } from "./support.styles";
import { Heading } from "../../components/headers/heading/heading.component";
import { ResponsiveTableHead } from "../../components/layout/responsive-table/responsive-table-thead.component";
import { ResponsiveTableBody } from "../../components/layout/responsive-table/responsive-table-tbody.component";

export const Support = () => {
  return (
    <SupportLayout>
      <Table>
        <ResponsiveTableHead>
          <TableRow>
            <TableCell>
              <Heading varient="secondary">Customer Support</Heading>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableHeading>For Inquiries on:</TableHeading>
            <TableHeading>Contact</TableHeading>
            <TableHeading>Hours (EST)</TableHeading>
            <TableHeading>Email</TableHeading>
          </TableRow>
        </ResponsiveTableHead>

        <ResponsiveTableBody>
          <TableRow>
            <TableCell>Technical Issues</TableCell>
            <TableCell>DCM Ecommerce Support</TableCell>
            <TableCell>8:00 a.m. to 5:00 p.m.</TableCell>
            <TableCell>ecommerce@datacm.com</TableCell>
          </TableRow>
        </ResponsiveTableBody>
      </Table>
    </SupportLayout>
  );
};
